import type { LocaleMessages } from './en';

export const es: LocaleMessages = {
  createYourOwn: {
    SIGN_IN_TO_USE_THIS_TEMPLATE:
      'Inicia sesión o crea una cuenta para personalizar este diseño como propio.',
    CUSTOMIZE_THIS_DESIGN_AS_YOUR_OWN: 'Personaliza este diseño como propio',
    MAKE_YOUR_OWN: 'Personalizar Diseño',
    SIGN_IN_OR_SIGN_UP: 'Iniciar sesión o Registrarse',
  },
  designLocked: {
    DESIGN_LOCKED_TITLE: 'Este diseño se está creando',
    DESIGN_LOCKED_TEXT:
      'Este diseño todavía se está creando. Intenta actualizar en un par de minutos.',
  },
  designPrivate: {
    DESIGN_PRIVATE_TITLE: 'Este diseño es privado',
    DESIGN_PRIVATE_TEXT:
      'La persona que compartió este diseño lo marcó como privado. Inicia sesión o haz público el diseño para verlo.',
  },
  designEmpty: {
    NO_RESULTS_TITLE: 'Este diseño está vacío',
    NO_RESULTS_MESSAGE:
      'La persona que creó este diseño aún no ha agregado nada.',
  },
  design404: {
    TITLE: 'No se puede encontrar el diseño',
    MESSAGE: 'El diseño que buscas no existe o ha sido eliminado.',
  },
  common: {
    LOADING: 'Cargando...',
    ERROR: 'Error',
    SUCCESS: 'Éxito',
    SOMETHING_WENT_WRONG: 'Algo salió mal',
  },
  actionBar: {
    GO_TO_FIRST_PAGE: 'Ir a la primera página',
    GO_TO_LAST_PAGE: 'Ir a la última página',
    DOWNLOAD: 'Descargar PDF',
    SIGN_OUT: 'Cerrar sesión',
  },
  companySwitcher: {
    SWITCH_COMPANIES: 'Cambiar empresa',
  },
  viewer: {
    PROMPT_TEXT:
      'Pruébalo ahora: Haz clic en un producto para ver más información',
    VIRTUALS_ARE_ILLUSTRATIVE_TEXT:
      'Las maquetas virtuales de productos son solo ilustrativas. La decoración final puede diferir.',
  },
  design: {
    DISCLAIMER:
      'Los precios y disponibilidad de los productos pueden cambiar. Por favor confirma antes de ordenar.',
  },
  productSidebar: {
    PRODUCT_INFO: 'Información del Producto',
    COLORS: 'Muestras de Colores',
    SIZES: 'Tamaños',
    MATERIALS: 'Materiales',
    PRICING: 'Precios',
    MOQ: 'Cantidad mínima de pedido',
    READ_FULL_DESCRIPTION: 'Leer descripción completa',
    DOWNLOAD: 'Descargar',
    NO_IMAGE_AVAILABLE: 'No hay imagen disponible',
    VIEW_ON_OUR_WEBSITE: 'Ver en nuestro sitio web',
  },
  pageSetup: {
    UPLOAD: 'Subir',
    CANCEL: 'Cancelar',
    DELETE: 'Eliminar',
    SEARCH: 'Buscar',
    BY: 'Por',
    ADD_IMAGE: 'Agregar imagen',
    ADD_COVER_DESCRIPTION: 'Agrega una imagen de portada a tu página',
    ADD_PRODUCT: 'Agregar producto',
    ADD_AN_IMAGE: 'Agregar una imagen',
    REPLACE_PRODUCT: 'Reemplazar producto',
    REMOVE_PRODUCT: 'Eliminar producto',
    SELECT_PRODUCT_SLOT:
      'Selecciona el producto que quieres mostrar en este espacio',
    NO_RESULTS: 'No se encontraron resultados',
    TRY_SOMETHING_DIFFERENT:
      'No pudimos encontrar imágenes que coincidan con tu búsqueda. Intenta algo diferente',
    DELETE_PRODUCT_CONFIRMATION: '¿Seguro que quieres eliminar este producto?',
    DELETE_LOGO_CONFIRMATION: '¿Seguro que quieres eliminar este logo?',
    DONE: 'Listo',
    DRAG_IMAGE_TO_REPOSITION: 'Arrastra la imagen para reposicionarla',
    REMOVE_IMAGE: 'Eliminar imagen',
    REPOSITION_IMAGE: 'Reposicionar imagen',
    COVER_MODE: 'Modo cubrir',
    CONTAIN_MODE: 'Modo contener',
    VIEW_ALL_INFO: 'Ver toda la información',
    VIEW_PRODUCT: 'Ver producto',
    SELECT_PRODUCT: 'Seleccionar producto',
    COLORS: 'Colores',
    SIZES: 'Tamaños',
    DESCRIPTION: 'Descripción',
    MORE_COLORS: 'Más colores',
    PRICE_FROM: 'Desde:',
    CALL_FOR_PRICING: 'Llama para precios',
    CLICK_FOR_PRICING: 'Clic para precio',
    EDIT_VIRTUAL_SAMPLE: 'Editar muestra virtual',
    REMOVE_VIRTUAL_SAMPLE: 'Eliminar muestra virtual',
    REPOSITION_LOGO: 'Reposicionar logo',
    EDIT_LOGO: 'Editar logo',
  },
};
